import { render } from "./MusicLibrary.vue?vue&type=template&id=44743e51&scoped=true&ts=true"
import script from "./MusicLibrary.vue?vue&type=script&lang=ts"
export * from "./MusicLibrary.vue?vue&type=script&lang=ts"

import "./MusicLibrary.vue?vue&type=style&index=0&id=44743e51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44743e51"]])

export default __exports__